import { useCustom } from "@refinedev/core";
import { Alert, Card, Col, Row, Statistic, Typography } from "antd";
import type { InstagramAccount, Stats } from "../api/client";

export const Dashboard = () => {
  // Refine v5 returns { query, result } rather than a bare react-query result.
  const { result: stats } = useCustom<Stats>({ url: "/api/stats", method: "get" });
  const { result: account } = useCustom<InstagramAccount>({
    url: "/api/instagram/account",
    method: "get",
  });

  const s = stats?.data;

  return (
    <>
      <Typography.Title level={4}>Обзор</Typography.Title>

      {/* A broken token shows up here first, before anyone wonders why replies stopped.
          A failed Graph call still resolves with a problem-details body, so the presence of a real
          userId — not the absence of an error — is what proves the connection works. */}
      {!account?.data?.userId ? (
        <Alert
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
          message="Нет связи с Instagram"
          description="Проверьте META_PAGE_ACCESS_TOKEN и права приложения."
        />
      ) : (
        <Alert
          type="success"
          showIcon
          style={{ marginBottom: 16 }}
          message={`Подключён аккаунт @${account.data.username ?? account.data.userId}`}
        />
      )}

      <Row gutter={[16, 16]}>
        <Col xs={12} md={6}>
          <Card>
            <Statistic title="Активных заданий" value={s?.enabledTrackedPostCount ?? 0} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card>
            <Statistic title="Всего постов" value={s?.trackedPostCount ?? 0} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card>
            <Statistic title="Срабатываний за 24ч" value={s?.triggeredLast24Hours ?? 0} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card>
            <Statistic
              title="Ждут ответа"
              value={s?.awaitingReply ?? 0}
              valueStyle={{ color: (s?.awaitingReply ?? 0) > 0 ? "#d46b08" : undefined }}
            />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card>
            <Statistic
              title="Ошибок за 24ч"
              value={s?.failedLast24Hours ?? 0}
              valueStyle={{ color: (s?.failedLast24Hours ?? 0) > 0 ? "#cf1322" : undefined }}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};
